import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";
import Model from "../Model";

/**
 * ErrorModal — uses the universal Model shell for consistent UI.
 */
const ErrorModal = ({ message, subMessage, onClose }) => {
  return (
    <Model isOpen={true} onClose={onClose} name="Error" widthClass="max-w-md">
      <div className="p-8 flex flex-col items-center text-center gap-5">
        {/* Animated warning icon */}
        <motion.div
          className="w-16 h-16 rounded-full bg-amber-50 border border-amber-100 flex items-center justify-center"
          animate={{ scale: [1, 1.08, 1] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
        >
          <AlertTriangle size={30} className="text-amber-500" strokeWidth={2} />
        </motion.div>

        <div className="flex flex-col gap-2">
          <h2 className="text-[15px] font-black text-slate-800 uppercase tracking-tight leading-snug">
            {message || "Oops! Something went wrong."}
          </h2>
          <p className="text-[12px] text-slate-500 font-medium leading-relaxed">
            {subMessage || "Please try again or contact support if the issue persists."}
          </p>
        </div>

        <button
          onClick={onClose}
          className="mt-2 px-8 py-2 bg-primary hover:bg-[#2c5ebc] text-white font-black text-[10px] uppercase tracking-[2px] border border-primary transition-all"
        >
          Dismiss
        </button>
      </div>
    </Model>
  );
};

export default ErrorModal;
